import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { uiChangeSkladName } from '../../../../actions/ui';
import WarehouseCommonApi from '../../../../API/warehouse/common-api';
import { Column, Row } from '../../../../components/Basic/Blocks';
import { LinkBlue } from '../../../../components/Basic/Elements';
import { Content } from '../../../../components/Basic/Global';
import { Select } from '../../../../components/Basic/Inputs';
import { H1 } from '../../../../components/Basic/WrapsStyle';
import { SKLADS_WAREHOUSE } from '../../../../constans';
import WarehouseProductHistory from '../ProductHistory';
import InfoBlock from './InfoBlock';
import MarketBlock from './MarketsPairsBlock';

function WarehouseProductPage() {

  const { id } = useParams()
  const [isInventory, setIsInventory] = useState(false);

  const skladName = useSelector(store => store.ui.skladName);
  const user = useSelector(store => store.user);

  const [product, setProduct] = useState({});
  const [productMarket, setProductMarket] = useState({});

  const [load, setLoad] = useState(false);
  const [error, setError] = useState('');

  const dispatch = useDispatch();


  useEffect(() => {
    WarehouseCommonApi.getOneProduct({ data: { id } })
      .then((res) => {
        setProduct(res.product);
        setProductMarket(res.marketCards);
        setLoad(true);
      })
      .catch((err) => {
        console.log(err);
        if (err.code === 120) {
          setError('Не удалось найти товар в базе');
        }
      });
  }, []);



  return (
    <Content>
      <Row spaceBetween={true}>
        <H1 style={{ marginBottom: 0 }}>{error.length > 0 ? error : product.name}</H1>
        <div>
          <Select
            label="Город"
            select={skladName}
            list={SKLADS_WAREHOUSE.filter(item => user.sklads[item.short_name])}
            valueFn={(p) => p.name}
            onSelect={(v) => dispatch(uiChangeSkladName(v))}
            width="200px"
            style={{ marginRight: '15px' }}
          />
        </div>
      </Row>
      <LinkBlue to={'/warehouse/products'} style={{ marginBottom: '10px' }}>
        Вернуться к товарам
      </LinkBlue>
      <Row style={{ alignItems: 'flex-start', width: '100%' }}>
        {load && <InfoBlock p={product} save={(p) => setProduct(p)} isInventory={isInventory} skladData={product.sklad_data[skladName.short_name]} />}
        <Column>
          {load && <WarehouseProductHistory history={product.sklad_data[skladName.short_name].history} />}
          {load && <MarketBlock id={product.id} marketsCard={productMarket} />}
        </Column>
      </Row>
    </Content>
  );
}

export default WarehouseProductPage;
